import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface DataClassData {
  dataClass: {
    schema: {
      [key: string]: unknown;
    };
    uiSchema: {
      [key: string]: unknown;
    };
  };
}

interface CreateData {
  input: string;
  schema: {};
  uiSchema: {};
  container?: string;
}

export function useDataClassCreate() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (createData: CreateData): Promise<DataClassData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/generate_dataclass_new`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(createData),
        }
      );

      let data = await response.json();

      const { dataClass } = data?.data;

      return {
        dataClass: dataClass,
      };
    },
  });
}
